// MySQL datetimes come back space-separated ("2026-05-09 12:59:28"). Safari's
// Date() rejects that form and returns "Invalid Date", so normalise the space
// to a 'T' before parsing.
export function fmtDate(d: string) {
  if (!d) return '—'
  const iso = d.includes('T') ? d : d.replace(' ', 'T')
  const dt = new Date(iso)
  return isNaN(dt.getTime())
    ? '—'
    : dt.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
}
